var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarketplace = function SvgMarketplace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.119 83.119",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccd7dc",
    d: "M34.254 83.119v-7.468a9.741 9.741 0 0 1 0-19.481v-7.305H20.642l1.158-3.253a4.8 4.8 0 0 0 .278-1.617 4.87 4.87 0 0 0-9.741 0 4.8 4.8 0 0 0 .278 1.617l1.158 3.253H0a37.06 37.06 0 0 0 34.254 34.254",
    "data-name": "Pfad 385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccd7dc",
    d: "M17.208 34.254a9.75 9.75 0 0 1 9.741 9.741h7.305V30.382l3.253 1.158a4.869 4.869 0 1 0 0-9.184l-3.253 1.158V10.026A36.79 36.79 0 0 0 0 43.994h7.468a9.75 9.75 0 0 1 9.74-9.74",
    "data-name": "Pfad 386"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccd7dc",
    d: "M73.093 48.865h-7.182a9.741 9.741 0 0 1-19.481 0h-7.305v13.612l-3.253-1.158a4.869 4.869 0 1 0 0 9.184l3.253-1.158v13.774a36.79 36.79 0 0 0 33.968-34.254",
    "data-name": "Pfad 387"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f08d23",
    d: "M73.216 19.643V9.9h-9.74a9.742 9.742 0 1 0-19.481 0h-4.871v7.305a9.741 9.741 0 1 1 0 19.481v7.305h13.612l-1.158 3.253a4.8 4.8 0 0 0-.278 1.617 4.87 4.87 0 0 0 9.741 0 4.8 4.8 0 0 0-.278-1.617l-1.158-3.253h13.612v-4.87a9.89 9.89 0 0 0 9.9-9.741 9.89 9.89 0 0 0-9.901-9.737",
    "data-name": "Pfad 388"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarketplace);
export default ForwardRef;